import { NoticeBoardService } from '@administration/notice-board/notice-board.service';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ExtendedBaseTab } from '@common/classes/extended-base-tab';
import { ModalService } from '@common/services/modal.service';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { CustomExtendedTabService } from 'app/singleton-services/custom-extended-tab.service';
import { orderBy } from 'lodash-es';

@Component({
    selector: 'app-tab-notifications',
    templateUrl: './tab-notifications.component.html',
    styleUrls: ['./tab-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabNotificationsComponent extends ExtendedBaseTab implements OnInit {
    notifications: any[] = [];

    constructor(
        public activeModal: DialogRef,
        private service: NoticeBoardService,
        private kendoDialogService: DialogService,
        private modalService: ModalService,
        customExtendedTabService: CustomExtendedTabService
    ) {
        super(customExtendedTabService);
    }

    ngOnInit(): void {
        this.defaultPaging();
        this.getNotifications();
    }

    // this is not to include fitColumns in the grid
    loadItems(model: any) {
        const ordered = orderBy(model, this.sort);

        this.itemsGridView = {
            data: ordered.slice(this.itemPage.skip, this.itemPage.skip + this.itemPage.pageSize),
            total: model.length
        };
        this.isBusy = false;
    }

    public openAttachments(rowId: number) {
        this.isBusy = true;
        this.service.getNotificationAttachments(rowId).subscribe((response) => {
            this.modalService.openAttachmentList({ notificationAttachments: response, openedAttachmentId: rowId });
            this.isBusy = false;
        });
    }

    private getNotifications() {
        this.isBusy = true;
        this.service.getNotificationsOnLogin().subscribe((response) => {
            this.notifications = response;
            this.loadItems(this.notifications);
            this.isBusy = false;
        });
    }
}
